import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function TeamPayIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 1.75C14.5563 1.75 18.25 5.44365 18.25 10C18.25 14.5563 14.5563 18.25 10 18.25C5.44365 18.25 1.75 14.5563 1.75 10C1.75 5.44365 5.44365 1.75 10 1.75ZM10 3.25C6.27208 3.25 3.25 6.27208 3.25 10C3.25 13.7279 6.27208 16.75 10 16.75C13.7279 16.75 16.75 13.7279 16.75 10C16.75 6.27208 13.7279 3.25 10 3.25ZM10.8184 7.75488H13V9.39062H10.8184V10.5654H13V12.2021H10.8184V14.6367H9.18164V12.2021H7V10.5654H9.18164V9.39062H7V7.75488H9.18164V5.36426H10.8184V7.75488Z"
          fill="currentColor"
        />
      </svg>
    </IconWrapper>
  )
}
